var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEstime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#263C46",
    strokeDasharray: 2,
    d: "M10 19a9 9 0 1 0 0-18 9 9 0 0 0 0 18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263C46",
    d: "M15.631 6.751a.5.5 0 0 0-.683-.183l-4.92 2.841-3.835-2.686a.5.5 0 0 0-.573.819l4.096 2.868.003.002.026.016.007.004a.182.182 0 0 0 .033.018l.031.014.019.007.014.005.02.006.013.004.02.005.014.003.019.003.018.002.016.002.035.001a.544.544 0 0 0 .057-.003h.001a.53.53 0 0 0 .055-.01l.004-.001a.339.339 0 0 0 .051-.017l.007-.003a.396.396 0 0 0 .047-.021l.009-.005.017-.01 5.196-3a.498.498 0 0 0 .183-.681z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEstime);
export default __webpack_public_path__ + "static/media/ic-estime.114524fc0e6921e768e0a8d450c5d5c6.svg";
export { ForwardRef as ReactComponent };